import { HttpMethod } from '../../http-method'
import { ICreateRmaRequest, POSTRMAServiceOption, POSTRma, POSTSupplierOrderRma, PUTRma, RMASettings } from '.'
import { IPaginatedRequest } from '../../request'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const getRmas = (params: IPaginatedRequest) => ({
  method: 'GET',
  url: '/modules/rma/list/lines',
  params
})

export const getRmaReasons = () => ({
  method: 'GET',
  url: '/modules/rma/reasons'
})

export const getRmaReturnDetails = (uuid: string) => ({
  method: 'GET',
  url: `/modules/rma/returns/${uuid}`
})

export const createRma = (request: ICreateRmaRequest) => ({
  method: 'POST',
  url: '/modules/rma/returns',
  data: request
})

export const searchRmaLinesByArchiveOrderUUIDReq = (archiveUUID: string) => ({
  method: 'GET',
  url: `/modules/archive/${archiveUUID}/search-rma`
})

export const searchRmaLinesByArchiveLineUUIDReq = (archiveUUID: string, lineUUID: string) => ({
  method: 'GET',
  url: `/modules/archive/${archiveUUID}/lines/${lineUUID}/search-rma`
})

export const searchRmaLinesByArchiveOrderUUIDViaProductSearchReq = (archiveUUID: string) => ({
  method: 'GET',
  url: `/modules/archive/v3/${archiveUUID}/search-rma`
})

export const searchRmaLinesByArchiveLineUUIDViaProductSearchReq = (archiveUUID: string, lineUUID: string) => ({
  method: 'GET',
  url: `/modules/archive/v3/${archiveUUID}/lines/${lineUUID}/search-rma`
})

export const searchRmaLinesByWholesalerOrderUUIDReq = (uuid: string) => ({
  method: 'GET',
  url: `/modules/orders/${uuid}/search-rma`
})

export const searchRmaLinesByWholesalerOrderLineUUIDReq = (orderUUID: string, lineUUID: string) => ({
  method: 'GET',
  url: `/modules/orders/${orderUUID}/rows/${lineUUID}/search-rma`
})

export const createRmaReq = (request: POSTRma) => ({
  method: 'POST',
  url: '/modules/rma/returns',
  data: request
})

export const createRmaV2Req = (request: POSTRma) => ({
  method: 'POST',
  url: '/modules/rma/returns/v2',
  data: request
})

export const createRmaForSupplierOrderReq = (request: POSTSupplierOrderRma) => ({
  method: 'POST',
  url: '/modules/rma/returns/supplier-order',
  data: request
})

export const updateRmaReq = (uuid: string, request: PUTRma) => ({
  method: HttpMethod.PUT,
  url: `/modules/rma/returns/${uuid}`,
  data: request
})

export interface OrderKey {
  OrderUUID: string
  OrderRowUUID: string
}
export interface ISearchRmaLinesByMultipleWholesalerOrdersInput {
  OrderRows: OrderKey[]
}
export const searchRmaLinesByMultipleWholesalerOrdersReq = (body: ISearchRmaLinesByMultipleWholesalerOrdersInput) => ({
  method: 'POST',
  url: `/modules/orders/search-rma-multiple-order-rows`,
  data: body
})

export const searchRmaLinesByMultipleWholesalerOrdersViaProductSearchReq = (body: ISearchRmaLinesByMultipleWholesalerOrdersInput) => ({
  method: 'POST',
  url: `/modules/orders/search-rma-multiple-order-rows-v2`,
  data: body
})

export interface ISearchRmaLinesBySupplierOrderInput {
  OrderNumber: string
  LineNumbers?: number[]
}
export const searchRmaLinesBySupplierOrderNumberReq = (body: ISearchRmaLinesBySupplierOrderInput) => ({
  method: 'POST',
  url: `/modules/supplier-orders/search-rma`,
  data: body
})

export const searchRmaLinesBySupplierOrderNumberViaProductSearchReq = (body: ISearchRmaLinesBySupplierOrderInput) => ({
  method: 'POST',
  url: `/modules/supplier-orders/search-rma-v2`,
  data: body
})

export const getReturnSettings = () => ({
  method: 'GET',
  url: `/modules/rma/settings`
})

export const putReturnSettings = (newValues: RMASettings) => ({
  method: 'PUT',
  url: `/modules/rma/settings`,
  data: newValues
})

export const getRMAServiceOptionsReq = (orderAccountUUID: string) => ({
  method: HttpMethod.GET,
  url: `/modules/orders/rma/service-options/${orderAccountUUID}`
})

export const postRMAServiceOptionsReq = (RMAServiceOption: POSTRMAServiceOption) => ({
  method: HttpMethod.POST,
  url: `/modules/rma/returns-special`,
  data: RMAServiceOption
})

export const getRMAPickupPdf = (rmaNumber: string) =>
  createAsyncApiAction<Blob>('gms', {
    method: 'GET',
    url: `/modules/rma/document/${rmaNumber}`
  })
